import { Microfrontend } from '@cian/mf-react';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';
import { useSelector } from 'react-redux';

import * as styles from './DesktopFiltersMicrofrontend.css';
import { useFiltersUpdatedEvent } from './hooks/useFiltersUpdatedEvent';
import { useSaveSearchButtonEvent } from './hooks/useSaveSearchButtonEvent';
import { serializePuids } from './utils/serializePuids';
import { getDateRangeValue } from '../../../../packages/JsonQuery';
import { DESKTOP_FILTERS_MICROFRONTEND_MANIFEST } from '../../constants/microfrontends';
import { selectJsonQuery } from '../../selectors/filters';
import { selectPuids } from '../../selectors/listingOffers';
import { selectIsUserAgent } from '../../selectors/user/user';
import { useApplicationContext } from '../ApplicationContext';

import type { JsonObject } from '@cian/mf-react/shared/types/json';

export const DesktopFiltersMicrofrontend: React.FC = () => {
  const {
    config,
    microfrontendsAPI,
    microfrontendsRegistry,
    custom: { source },
  } = useApplicationContext();
  const manifest = config.get<IMicrofrontendManifest>(DESKTOP_FILTERS_MICROFRONTEND_MANIFEST);

  useFiltersUpdatedEvent();
  useSaveSearchButtonEvent();

  const isUserAgent = useSelector(selectIsUserAgent);
  const adfoxPuids = useSelector(selectPuids);
  const jsonQuery = useSelector(selectJsonQuery);
  const hasNoDates = !getDateRangeValue('dates')(jsonQuery);

  const parameters = React.useMemo(
    () => ({
      adfoxPuids: serializePuids(adfoxPuids),
      professionalSearchAvailable: isUserAgent,
      jsonQuery: jsonQuery as unknown as JsonObject,
    }),
    [adfoxPuids, isUserAgent, jsonQuery],
  );

  React.useEffect(() => {
    if (
      source === 'search_string' &&
      hasNoDates &&
      microfrontendsRegistry.microfrontend('desktop-filters-micro-frontend') &&
      microfrontendsAPI
    ) {
      microfrontendsAPI.desktopFilters.openDatesPopup();
    }
  }, [hasNoDates, microfrontendsAPI, microfrontendsRegistry, source]);

  if (!manifest) {
    return null;
  }

  return (
    <div className={styles['root']} data-testid="desktop-filters-microfrontend">
      <Microfrontend
        name={manifest.microfrontendName}
        image={manifest.imageVersion}
        runtime={manifest.runtimeName}
        instance={manifest.instanceId}
        parameters={parameters}
      />
    </div>
  );
};
